import { gql } from "@apollo/client";

export const DO_TERMINAL_CALIBRATION = gql`
  mutation DoCalibration($domain: String!, $terminalid: Int!, $triggerAmount: Int!, $pauseTime: Int!, $calibrationAmount: Int!) {
    terminal {
      doCalibration(domain: $domain, terminalid: $terminalid, triggerAmount: $triggerAmount, pauseTime: $pauseTime, calibrationAmount: $calibrationAmount) {
        code
        success
        message
      }
    }
  }
`

export interface DoTerminalCalibration {
  domain: string
  terminalid: number
  triggerAmount: number
  pauseTime: number
  calibrationAmount: number
}

interface DoTerminalCalibrationAction {
  code: String
  success: Boolean
  message: string
}

export interface DoTerminalCalibrationResponse {
  terminal: {
    doCalibration: DoTerminalCalibrationAction
  }
}